import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFileWord = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 165,
	height: 216,
	viewBox: "0 0 165 216",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			opacity: .3,
			children: /* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M139.71 49.24C134.241 49.2373 128.997 47.0644 125.129 43.1982C121.261 39.3321 119.085 34.0889 119.08 28.62V0H26.9099C23.3752 -2.4406e-07 19.8751 0.696337 16.6096 2.04932C13.3441 3.4023 10.3771 5.38537 7.87818 7.88525C5.37922 10.3851 3.3973 13.3529 2.04553 16.6189C0.693768 19.8849 -0.00131167 23.3853 1.85821e-06 26.92V189.13C0.0106002 196.26 2.85042 203.094 7.89588 208.132C12.9413 213.17 19.7799 216 26.9099 216H137.51C141.045 216 144.545 215.304 147.81 213.951C151.076 212.598 154.043 210.615 156.542 208.115C159.041 205.615 161.023 202.647 162.375 199.381C163.726 196.115 164.421 192.615 164.42 189.08V49.2L139.71 49.24Z",
				fill: "#1969AD"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.42 49.24H139.71C134.241 49.2373 128.997 47.0644 125.129 43.1982C121.261 39.3321 119.085 34.0889 119.08 28.62V0L164.42 49.24Z",
			fill: "#1969AD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.417 85.0833H81V138.917H117.417V85.0833Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.417 140.5H85.7501C84.8749 140.5 84.1667 139.792 84.1667 138.917C84.1667 138.042 84.8749 137.333 85.7501 137.333H115.833V86.6667H85.7501C84.8749 86.6667 84.1667 85.9585 84.1667 85.0833C84.1667 84.2082 84.8749 83.5 85.7501 83.5H117.417C118.292 83.5 119 84.2082 119 85.0833V138.917C119 139.792 118.292 140.5 117.417 140.5Z",
			fill: "#015CAB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.3333 74L43 82.2609V141.739L87.3333 150V74Z",
			fill: "#015CAB"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M43 82.2609V83.0526L87.3333 74.7917V74L43 82.2609Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M43 141.739L87.3333 150V149.208L43 140.948V141.739Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.083 91.4167H85.75V94.5834H111.083V91.4167Z",
			fill: "#015CAB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.083 100.917H85.75V104.083H111.083V100.917Z",
			fill: "#015CAB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.083 110.417H85.75V113.583H111.083V110.417Z",
			fill: "#015CAB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.083 119.917H85.75V123.083H111.083V119.917Z",
			fill: "#015CAB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.083 129.417H85.75V132.583H111.083V129.417Z",
			fill: "#015CAB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.417 140.5C118.292 140.5 119 139.792 119 138.917V115.167L87.3333 83.5V140.5H117.417Z",
			fill: "url(#paint0_linear_156_187)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.1353 126.349L71.5011 126.589L78.5099 100.076L73.4982 100.434L69.8362 114.163C69.8362 114.163 67.9738 107.387 66.2055 100.955L60.8561 101.337L57.3303 114.163L54.039 101.824L49.21 102.169L55.3606 125.436L59.2133 125.711L63.5833 110.416C63.5833 110.416 66.0928 119.2 68.1353 126.349Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .05,
			d: "M87.3333 74L43 82.2609V141.739L87.3333 150V74Z",
			fill: "url(#paint1_linear_156_187)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.417 83.5H87.3333V74L43 82.2609V141.739L87.3333 150V140.5H117.417C118.292 140.5 119 139.792 119 138.917V85.0833C119 84.2082 118.292 83.5 117.417 83.5Z",
			fill: "url(#paint2_linear_156_187)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_156_187",
				x1: 73.0833,
				y1: 97.75,
				x2: 116.953,
				y2: 141.62,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopOpacity: .1 }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_156_187",
				x1: 42.9974,
				y1: 111.998,
				x2: 87.3335,
				y2: 111.998,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", { offset: 1 })]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_156_187",
				x1: 38.0491,
				y1: 92.8782,
				x2: 122.31,
				y2: 132.17,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .2
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
export default SvgIconFileWord;
